import { Card, Flex, Typography } from 'antd';

export const InsightCard = ({ title, amount, label, Icon, color }) => {
  return (
    <Card style={{ boxShadow: '0 2px 8px #f0f1f2' }}>
      <Flex align="center" justify="space-between">
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 14 }}>
            {title}
          </Typography.Text>
          <div style={{ fontSize: 32, fontWeight: 600, color: color || '#27ae60', lineHeight: 1 }}>{amount}</div>
          <Typography.Text type="secondary" style={{ fontSize: 13 }}>
            {label}
          </Typography.Text>
        </div>
        <Icon style={{ fontSize: 24, color: '#222', opacity: 0.7 }} />
      </Flex>
    </Card>
  );
};
